import { Model } from 'pinia-orm';
import { Attr, BelongsTo, MorphMany, Num, Str } from 'pinia-orm/dist/decorators';
import Claim from './Claim';
import Comment from './Comment';
import Labour from './Labour';
import Plant from './Plant';
/* --- user header --- */
/* --- end user header --- */

export const DayworksType = {
  labour: 'labour',
  plant: 'plant',
} as const;

export default class DayworksCost extends Model {
  static entity = 'App\\Models\\DayworksCost';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare claim_id: number;
  @Str('')
  declare type: ObjectValues<typeof DayworksType>;
  @Num(undefined)
  declare labour_id: number | undefined;
  @Num(undefined)
  declare plant_id: number | undefined;
  @Num(undefined)
  declare current_claim: number | undefined;
  @Num(undefined)
  declare current_certified: number | undefined;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  // relations
  @BelongsTo(() => Claim, 'claim_id', 'id')
  declare claim: Claim;
  @BelongsTo(() => Labour, 'labour_id', 'id')
  declare labour: Labour;
  @BelongsTo(() => Plant, 'plant_id', 'id')
  declare plant: Plant;
  @MorphMany(() => Comment, 'commentable_id', 'commentable_type', 'id')
  declare comments: Comment[];
  /* --- user code --- */

  @Attr(undefined)
  declare $calculated_amount: number | undefined;
  @Attr(undefined)
  declare $previous: number | undefined;

  get description(): string {
    if(this.type === DayworksType.labour) {
      return `${this.labour?.first_name ?? ''} ${this.labour?.last_name ?? ''}`.trim();
    }

    return this.plant?.description ?? '';
  }

  get code(): string {
    if(this.type === DayworksType.labour) {
      return 'Labour';
    }

    return this.plant?.fleet ?? 'Plant';
  }

  /* --- end user code --- */
}
